module.exports = __webpack_public_path__ + "797ed607a25b37cef8aad9653c5dc973.png";